import React from 'react';
import archieml from 'archieml';
import Article from 'containers/Article/Article';

import data from 'data';

const App = React.createClass({
  displayName: "App",
  render () {
    const articleData = archieml.load(data);
    return (
      <Article data={articleData}/>
    );
  }
});

export default App;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/containers/App.js
 **/